import React from 'react';
import st from './style.module.scss';

const SectionTitle = ({ titleWord, accentTitleWord }) => {
  return (
    <div className={st.titleWrapper}>
      <div className="col-12 d-flex justify-content-between align-items-center">
        <h3>
          <span>{titleWord}</span>
          <span style={{ color: '#882e2e' }}>{accentTitleWord}</span>
        </h3>
      </div>
    </div>
  );
};

export default SectionTitle;
